import React from 'react';
import { Target, Users, Building2, Briefcase, Globe2 } from 'lucide-react';
import { Section } from './ui/Section';
const stakeholders = [{
  icon: Building2,
  title: 'TVET Institutions & Training Centres',
  description: 'Comprehensive support for quality improvement and modernisation'
}, {
  icon: Briefcase,
  title: 'Ministries & Public Authorities',
  description: 'Policy development and system-wide TVET reform'
}, {
  icon: Target,
  title: 'Accreditation & QA Bodies',
  description: 'Framework development and capacity strengthening'
}, {
  icon: Users,
  title: 'Employers & Sectoral Skills Councils',
  description: 'Labour-market alignment and partnership facilitation'
}, {
  icon: Globe2,
  title: 'Development & Donor Programmes',
  description: 'Technical assistance and programme implementation'
}];
export function WhyChooseSection() {
  return <section className="py-16 bg-navy text-white" data-id="element-123">
      <div className="container mx-auto px-8" data-id="element-124">
        <div className="mb-12" data-id="element-125">
          <h2 className="text-gold font-medium tracking-widest uppercase text-sm mb-3" data-id="element-126">
            Our TVET Approach
          </h2>
          <h3 className="text-4xl font-bold mb-6 font-serif" data-id="element-127">
            Structured, Needs-Driven Methodology
          </h3>
          <p className="text-gray-300 max-w-3xl leading-relaxed mb-8" data-id="element-128">
            Every TVET engagement follows a structured, needs-driven methodology
            that ensures all interventions are context-sensitive, practical,
            sustainable, and impact-oriented.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 mb-12 page-break-inside-avoid" data-id="element-129">
            <div className="px-6 py-3 bg-gold text-navy font-bold" data-id="element-130">Assess</div>
            <div className="text-gold text-2xl" data-id="element-131">→</div>
            <div className="px-6 py-3 bg-gold text-navy font-bold" data-id="element-132">Design</div>
            <div className="text-gold text-2xl" data-id="element-133">→</div>
            <div className="px-6 py-3 bg-gold text-navy font-bold" data-id="element-134">
              Implement
            </div>
            <div className="text-gold text-2xl" data-id="element-135">→</div>
            <div className="px-6 py-3 bg-gold text-navy font-bold" data-id="element-136">Monitor</div>
            <div className="text-gold text-2xl" data-id="element-137">→</div>
            <div className="px-6 py-3 bg-gold text-navy font-bold" data-id="element-138">Improve</div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-12" data-id="element-139">
          <h3 className="text-3xl font-bold mb-8 font-serif text-center" data-id="element-140">
            <span className="text-gold" data-id="element-141">Who We Work With</span>
          </h3>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-142">
            {stakeholders.map((stakeholder, index) => <div key={index} className="p-6 bg-white/5 border border-white/10 page-break-inside-avoid" data-id="element-143">
                <stakeholder.icon className="w-10 h-10 text-gold mb-4" data-id="element-144" />
                <h4 className="text-lg font-bold mb-2 font-serif" data-id="element-145">
                  {stakeholder.title}
                </h4>
                <p className="text-sm text-gray-400 leading-relaxed" data-id="element-146">
                  {stakeholder.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}